import { get, post } from 'pc-sales/utils/http';

export class ClueApi {
    // 获取销售线索列表(客户)
    get = async (
        data: {
            page?: number;
            pagesize?: number;
            status?: number;
            follow_up_status?: number; // 跟进状态
            from?: string;
            to?: string;
            source?: string;
            clue_name?: string;
            clue_email?: string;
            clue_phone?: string;
            uuid?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/sales/clue', data, { signal: options?.signal });

    // 获取销售线索列表(团队)
    team = async (
        data: {
            page?: number;
            pagesize?: number;
            status?: number;
            follow_up_status?: number;
            audit_status?: string;
            from?: string;
            to?: string;
            source?: string;
            clue_name?: string;
            clue_email?: string;
            clue_phone?: string;
            sales_email?: string;
            sales_phone?: string;
            uuid?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/sales/clue/team', data, { signal: options?.signal });

    // 获取销售线索信息
    info = (data: {
        clue_id: string;
        isDecrypt?: boolean; // 是否解密
    }) => get('/v2/sales/clue/show', data);

    // 更新线索
    update = (data: {
        clue_id: string;
        clue_name: string;
        uemail: string;
        uphone?: string;
        uphonecode?: string;
        // clue_status: string;
        domain?: string;
        status?: number;
        follow_up_status: number;
        sales_uuid?: string; // 所属销售id，更新团队线索时可传
        remark?: string;
    }) => post('/v2/sales/clue/update', data);

    // 线索绑定客户
    band = async (data: { clue_id: string; uuid: string }) => await post('/v2/sales/clue/band', data);

    // 添加线索
    create = (data: {
        clue_name: string;
        uemail: string;
        uphone?: string;
        uphonecode?: string;
        // clue_status: string;
        domain?: string;
        follow_up_status: number;
        remark?: string;
    }) => post('/v2/sales/clue/create', data);

    // 删除线索
    delete = async (data: { clue_id: string }) => await post('/v2/sales/clue/del', data);

    // 线索转化
    transform = (data: {
        clue_id: string;
        firstname: string;
        lastname: string;
        uphone?: string;
        uphonecode?: string;
        uemail: string;
        currency: string;
        uroleid: string;
        uhead: Object;
        sales?: string; // 更新团队线索时必传
        agent?: string;
    }) => post('/v2/sales/clue/transform', data);

    // 获取跟进记录
    getRecord = async (data: { clue_id: string; page?: number; pagesize: number }) =>
        await get('/v2/sales/clue/record', data);

    // 获取用户详情跟进记录
    clientRecord = async (data: { uuid: string; page?: number; pagesize: number }) =>
        await get('/v2/sales/clue/clientRecord', data);

    // 更新跟进记录
    setRecord = (data: {
        clue_id?: string;
        content: string;
        follow_type: 'interview' | 'immediate' | 'phone' | 'email';
        id?: string;
        transform_uuid?: string;
    }) => {
        if (data.id) {
            return post('/v2/sales/clue/record/update', data);
        } else {
            return post('/v2/sales/clue/record', data);
        }
    };

    // 删除跟进记录
    del = async (data: { id: string }) => await post('/v2/sales/clue/record/del', data);

    // 线索唯一性校验
    validate = async (
        data: {
            uemail?: string;
            phone?: string[];
        },
        options?: {
            ignoreError: boolean;
        },
    ) => await post('/v2/sales/clue/validate', data, options);

    // 查找销售线索（返回加密数据）
    search = async (
        data: {
            uemail?: string;
            uphone?: string;
            certificate?: string[];
        },
        options?: {
            ignoreError: boolean;
        },
    ) => await post('/v2/sales/clue/search', data, options);

    // 获取当天查询销售线索是否超过规定
    checkMore = async (options?: { ignoreError: boolean }) => await get('/v2/sales/clue/checkMore', options);

    // 下载销售线索导入模板
    downTemplate = () => get('/v2/sales/clue/downTemplate');

    // 下载本批次失败数据
    downError = async (data: { batchId: number }) => await get('/v2/sales/clue/downError', data);

    // 销售线索批量列表数据
    batchImportList = async (
        data: {
            batchId?: number;
            from?: string;
            to?: string;
            page?: number;
            pagesize?: number;
            emailOrPhone?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/sales/clue/batchImportList', data, { signal: options?.signal });

    // 销售线索批量列表数据
    batchImportDel = async (data: { clueId?: string }) => await post('/v2/sales/clue/batchImportDel', data);

    // 销售线索批量确定导入
    confirmBatchImport = async (data: { batchId: number }) => await get('/v2/sales/clue/confirmBatchImport', data);
}

export default new ClueApi();
